import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Container, Row, Col, Card, Form } from "react-bootstrap";
import Layout from "../page/layout";

const DetailTanamAktifPage = () => {
  const { id } = useParams();
  const [tanam, setTanam] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      setError("Token tidak ditemukan");
      setLoading(false);
      return;
    }

    const fetchTanamDetails = async () => {
      try {
        const response = await axios.get(
          "https://c-greenproject.org:8000/petanisapproved",
          {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true,
          }
        );

        if (!Array.isArray(response.data)) {
          throw new Error("Format data tidak valid");
        }

        const tanamData = response.data
          .flatMap(
            (entry) =>
              entry.rencanaTanamInfo?.map((rt) => ({
                ...rt,
                petanidasar: entry.petanidasar,
              })) || []
          )
          .find((item) => item.idtanam === id);

        if (tanamData) {
          setTanam(tanamData);
          console.log("State Tanam setelah fetch:", tanamData);
        } else {
          setError("Rencana Tanam tidak ditemukan");
        }
      } catch (error) {
        console.error("Error fetching order details:", error);
        setError(error.message || "Terjadi kesalahan saat mengambil data");
      } finally {
        setLoading(false);
      }
    };

    fetchTanamDetails();
  }, [id, token]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  return (
    <Layout>
      <Container className="mt-4">
        <h2 className="mb-1">
          <strong>
            Detail Rencana Tanam: {tanam?.idtanam || "Tidak Tersedia"}
          </strong>
        </h2>

        <Row className="mb-3">
          <h5> Status : {tanam?.statusRencanaTanam || "Tidak tersedia"}</h5>
        </Row>

        <Row className="mb-4">
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>ID Lahan</Form.Label>
              <Form.Control
                readOnly
                value={tanam?.petanidasar?.idlahan || "Tidak tersedia"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Tanggal Rencana Tanam</Form.Label>
              <Form.Control
                readOnly
                value={tanam?.tanggalRencanaTanam || "Tidak tersedia"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Lokasi Lahan</Form.Label>
              <Form.Control
                readOnly
                value={tanam?.petanidasar?.lokasilahan || "Tidak tersedia"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Varietas Singkong</Form.Label>
              <Form.Control
                readOnly
                value={tanam?.varietassingkong || "Tidak tersedia"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Jenis Pupuk</Form.Label>
              <Form.Control
                readOnly
                value={tanam?.jenispupuk || "Tidak tersedia"}
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Kategori Lahan</Form.Label>
              <Form.Control
                readOnly
                value={tanam?.petanidasar?.kategorilahan || "Tidak tersedia"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Tanggal Rencana Panen</Form.Label>
              <Form.Control
                readOnly
                value={tanam?.tanggalRencanaPanen || "Tidak tersedia"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Luas Lahan</Form.Label>
              <Form.Control
                readOnly
                value={
                  tanam?.petanidasar?.luaslahan
                    ? `${tanam.petanidasar.luaslahan} m²`
                    : "Tidak tersedia"
                }
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Estimasi Produksi</Form.Label>
              <Form.Control
                readOnly
                value={
                  tanam?.estimasiproduksi
                    ? `${tanam.estimasiproduksi} kg`
                    : "Tidak tersedia"
                }
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Catatan Tambahan</Form.Label>
              <Form.Control
                readOnly
                as="textarea"
                style={{ minHeight: "3px", resize: "none" }}
                value={tanam?.catatantambahan || "Tidak tersedia"}
              />
            </Form.Group>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default DetailTanamAktifPage;
